import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import locale from "@amcharts/amcharts4/lang/pt_BR.js";

function montarGraficoGroupStackedColumn({
    state,
    component,
    nome,
    dados = [],
    category,
    valuesAndNames = [],
    titulo,
    prefixo,
    sufixo,
    negativo = false,
    fontColor = "#ffffff",
    bullets = false,
    positionBullet = -7,
    dimensions = "3D",
    fontSizeTitle = 16,
    fontSizeLabel = null,
    fontWeightTitle = "normal",
    mostrarLegenda = false,
    chartBackground = null,
    individualBullets,
    individualBulletsColor,
    individualBulletsDy = -25,
    rotation = 0,
    showScrollBar = false,
    nameSerieBullets,
    dxIcone = 0,
    hideExport = false,
    centralizarVerticalmente = false,
    exibirBulletTotalizadorSeries = false,
    widthLegenda = null,
}) {
    //se não vier uma serie sai da função
    if (valuesAndNames[0] && !valuesAndNames[0].value) return;
    if (component) {
        component.dispose();
    }

    let chart = dimensions == "2D" ? am4core.create(nome, am4charts.XYChart) : am4core.create(nome, am4charts.XYChart3D);
    chart.colors.step = 1;

    if (state) {
        chart.colors.list = state.cores;
    }

    chart.language.locale = locale;

    let title = chart.titles.create();
    title.text = titulo;
    title.fontSize = fontSizeTitle;
    title.fontWeight = fontWeightTitle;
    title.marginBottom = 30;

    if (!hideExport) {
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "Gráfico";
        chart.exporting.menu.align = "right";
        chart.exporting.menu.verticalAlign = "top";
        chart.exporting.menu.items = [
            {
                label: "...",
                menu: [
                    {
                        type: "png",
                        label: "PNG",
                    },
                ],
            },
        ];
    }

    if (mostrarLegenda) {
        chart.legend = new am4charts.Legend();
        chart.legend.position = "top";
        chart.legend.paddingBottom = 20;

        // mantém colunas
        if (widthLegenda) {
            chart.legend.itemContainers.template.width = widthLegenda;
            const label = chart.legend.labels.template;
            label.wrap = true;
            label.truncate = false;
            label.textAlign = "start";
            label.valign = "top";
        } else {
            chart.legend.labels.template.maxWidth = 95;
        }
    }

    chart.language.locale["_decimalSeparator"] = ",";
    chart.language.locale["_thousandSeparator"] = ".";
    chart.numberFormatter.numberFormat = "###,###,###,###.00";

    chart.background.fill = chartBackground;
    chart.filters.clear();
    chart.paddingLeft = 10;
    chart.paddingRight = 20;

    chart.maskBullets = false;
    let xAxis = chart.xAxes.push(new am4charts.CategoryAxis());

    xAxis.renderer.labels.template.rotation = rotation; // negativo gira para baixo à esquerda
    xAxis.dataFields.category = category;
    xAxis.renderer.cellStartLocation = 0.1;
    xAxis.renderer.cellEndLocation = 0.9;
    xAxis.renderer.grid.template.location = 0;
    xAxis.paddingBottom = 15;
    xAxis.renderer.minGridDistance = 5;
    xAxis.renderer.labels.template.maxWidth = 150;
    xAxis.renderer.labels.template.wrap = true;
    xAxis.renderer.labels.template.truncate = false;

    let yAxis = chart.yAxes.push(new am4charts.ValueAxis());
    yAxis.min = negativo ? null : 0;

    if (bullets) {
        yAxis.extraMax = 0.3; // 30% de espaço extra no topo
    }

    let arrangeColumns = () => {
        let series = chart.series.getIndex(0);

        let w = 1 - xAxis.renderer.cellStartLocation - (1 - xAxis.renderer.cellEndLocation);
        if (series.dataItems.length > 1) {
            let x0 = xAxis.getX(series.dataItems.getIndex(0), "categoryX");
            let x1 = xAxis.getX(series.dataItems.getIndex(1), "categoryX");
            let delta = ((x1 - x0) / chart.series.length) * w;
            if (am4core.isNumber(delta)) {
                let middle = chart.series.length / 2;

                let newIndex = 0;
                chart.series.each(function (series) {
                    if (!series.isHidden && !series.isHiding) {
                        series.dummyData = newIndex;
                        newIndex++;
                    } else {
                        series.dummyData = chart.series.indexOf(series);
                    }
                });
                let visibleCount = newIndex;
                let newMiddle = visibleCount / 2;

                chart.series.each(function (series) {
                    let trueIndex = chart.series.indexOf(series);
                    let newIndex = series.dummyData;

                    let dx = (newIndex - trueIndex + middle - newMiddle) * delta;

                    series.animate({ property: "dx", to: dx }, series.interpolationDuration, series.interpolationEasing);
                    series.bulletsContainer.animate({ property: "dx", to: dx }, series.interpolationDuration, series.interpolationEasing);
                });
            }
        }
    };

    chart.data = [...dados];

    if (showScrollBar) {
        yAxis.strictMinMax = true; // impede autoajustes
        //--------------------------------------------------------------------------------
        chart.scrollbarX = new am4core.Scrollbar();

        // === Trilho de fundo ===
        chart.scrollbarX.background.fill = am4core.color("#f0f0f0"); // cinza bem claro
        chart.scrollbarX.background.fillOpacity = 1;
        chart.scrollbarX.background.strokeOpacity = 0;

        // === Parte móvel (thumb) ===
        chart.scrollbarX.thumb.background.fill = am4core.color("#d0d0d0"); // um pouco mais escuro
        chart.scrollbarX.thumb.background.fillOpacity = 1;
        chart.scrollbarX.thumb.background.stroke = am4core.color("#d0d0d0");
        chart.scrollbarX.thumb.background.cornerRadius(10, 10, 10, 10);

        // === Grips (extremidades) ===
        const startGrip = chart.scrollbarX.startGrip;
        const endGrip = chart.scrollbarX.endGrip;

        [startGrip, endGrip].forEach((grip) => {
            // Remove ícone padrão
            grip.icon.disabled = true;

            // Fundo
            grip.background.fill = am4core.color("#d0d0d0");
            grip.background.fillOpacity = 1;
            grip.background.stroke = am4core.color("#aaa");
            grip.background.cornerRadius(50, 50, 50, 50);
            grip.background.minWidth = 18;
            grip.background.minHeight = 18;

            // Hover
            const hover = grip.background.states.create("hover");
            hover.properties.fill = am4core.color("#bdbdbd");
        });

        // === Adiciona "<" e ">" nos grips ===
        const leftLabel = new am4core.Label();
        leftLabel.text = "< >";
        leftLabel.fontSize = fontSizeLabel || 14;
        leftLabel.fill = am4core.color("#555");
        leftLabel.horizontalCenter = "middle";
        leftLabel.verticalCenter = "middle";
        startGrip.children.push(leftLabel);

        const rightLabel = new am4core.Label();
        rightLabel.text = "< >";
        rightLabel.fontSize = fontSizeLabel || 14;
        rightLabel.fill = am4core.color("#555");
        rightLabel.horizontalCenter = "middle";
        rightLabel.verticalCenter = "middle";
        endGrip.children.push(rightLabel);

        // === Ajustes gerais ===
        chart.scrollbarX.height = 14;
        chart.scrollbarX.marginTop = 10;

        // === Efeito hover na thumb ===
        chart.scrollbarX.thumb.background.states.getKey("hover").properties.fill = am4core.color("#c2c2c2");
        //---------------------------------------------------------------------------------

        chart.events.on("datavalidated", function () {
            if (!chart.xAxes.values.length) return;

            const xAxis = chart.xAxes.values[0];
            const total = chart.data.length + 0.17; // adiciona um pequeno buffer para evitar corte de última categoria
            const limiteVisivel = 12; // número de categorias visíveis ao mesmo tempo

            if (total > limiteVisivel) {
                const proporcaoVisivel = (limiteVisivel / total);

                // 👇 Mostra os primeiros itens (início do gráfico)
                xAxis.zoom({ start: 0, end: proporcaoVisivel }, false, true);
            } else {
                // Mostra tudo
                xAxis.zoom({ start: 0, end: 1 }, false, true);
            }
        });
    }

    valuesAndNames.forEach((vn, idx) => {
        createSeries(vn.value, vn.name, vn.stacked, vn.linePattern, idx === valuesAndNames.length - 1, vn.hideZeroBullet, idx);
    });

    if (fontColor) {
        const cor = am4core.color(fontColor);

        // Cor da legenda
        if (mostrarLegenda) {
            chart.legend.labels.template.fill = cor;
        }

        // Cor do título
        title.fill = cor;

        // Cor dos labels do eixo X
        xAxis.renderer.labels.template.fill = cor;

        // Cor do título do eixo X (caso use)
        xAxis.title && (xAxis.title.fill = cor);

        // Cor dos labels do eixo Y
        yAxis.renderer.labels.template.fill = cor;

        // Cor do título do eixo Y (caso use)
        yAxis.title && (yAxis.title.fill = cor);

        // Cor dos valores dos tooltips (caso deseje alterar isso também)
        chart.tooltip.getFillFromObject = false;
        chart.tooltip.label.fill = cor;
    }

    function createSeries(value, name, stacked = false, linePattern, isLastSeries, hideZeroBullet = false) {
        // 🔹 Captura o índice da série atual
        const idx = chart.series.length;

        const series = dimensions == "2D" ? chart.series.push(new am4charts.ColumnSeries()) : chart.series.push(new am4charts.ColumnSeries3D());
        series.dataFields.valueY = value;
        series.dataFields.valueYPercentual = value + "_percentual";
        series.dataFields.valueYBullet = value + "_bullet";
        series.dataFields.valueYBulletTooltip = value + "_bullet_tooltip";
        series.dataFields.categoryX = category;
        series.name = name;
        series.stacked = stacked;

        series.events.on("hidden", arrangeColumns);
        series.events.on("shown", arrangeColumns);

        if (bullets) {
            // Adiciona imagens acima das colunas

            const bullet = series.bullets.push(new am4charts.LabelBullet());
            bullet.label.fontSize = fontSizeLabel || 12;

            //ALINHAMENTO VERTICAL
            if (centralizarVerticalmente) {
                bullet.locationY = 0.5; // meio da barra verticalmente
            } else {
                // 🔹 deslocamento vertical dinâmico conforme o índice da série
                const deslocamentoBase = positionBullet || -7;
                const deslocamentoEntreSeries = -15; // diferença entre cada série
                bullet.label.dy = individualBullets ? individualBulletsDy : deslocamentoBase + idx * deslocamentoEntreSeries;
            }

            bullet.interactionsEnabled = true;

            bullet.label.text = individualBullets ? "{valueYBullet}" : `${prefixo} {valueY} ${sufixo}`;
            bullet.label.fill = am4core.color(fontColor);
            bullet.label.truncate = false;
            bullet.label.fontWeight = "bold";

            // tooltip
            if (individualBullets) {
                bullet.label.tooltipText = "{valueYBulletTooltip}";
            }

            if (individualBullets) {
                // CENTRALIZAÇÃO
                bullet.label.horizontalCenter = "middle"; // centraliza o label no eixo
                bullet.label.textAlign = "middle"; // alinha o texto no centro
                bullet.label.fontSize = fontSizeLabel || 11;
                bullet.dy = -50;
                bullet.label.fill = am4core.color(individualBulletsColor); // vermelho
            }

            if (nameSerieBullets === name) {
                const image = bullet.createChild(am4core.Image);
                image.horizontalCenter = "middle";
                image.dy = -20;
                image.dx = dxIcone;
                image.width = 60;
                image.y = am4core.percent(100);
                image.propertyFields.href = "icone";
                image.propertyFields.fill = "color";
                image.tooltipText = "{icone_tooltip}";
                image.interactionsEnabled = true; // 🔥 Permite mostrar o tooltip

                image.filters.push(new am4core.DropShadowFilter());
            }

            // Bullet total fora da barra (somente na última série)
            if (exibirBulletTotalizadorSeries && isLastSeries) {
                const totalBullet = series.bullets.push(new am4charts.LabelBullet());
                totalBullet.label.fill = am4core.color(fontColor);
                totalBullet.label.fontWeight = "bold";
                totalBullet.label.fontSize = fontSizeLabel || 14;

                totalBullet.label.truncate = false;
                totalBullet.label.wrap = false;

                // 🔹 Centraliza horizontalmente e posiciona no topo
                totalBullet.label.horizontalCenter = "middle"; // centro horizontal
                totalBullet.label.verticalCenter = "top"; // parte de baixo do label encosta no topo da barra
                totalBullet.dy = -40;

                chart.maskBullets = false; // permite bullets fora do gráfico

                // 🔹 Texto do total (soma de cada pilha)
                totalBullet.label.adapter.add("text", (text, target) => {
                    const dataItem = target.dataItem;
                    if (!dataItem) return "";

                    const categoryValue = dataItem.categoryX;

                    // Soma apenas os valores POSITIVOS da categoria
                    const totalPositivo = valuesAndNames.reduce((acc, vn) => {
                        const item = dados.find((l) => l[category] === categoryValue);
                        const v = item ? Number(item[vn.value]) || 0 : 0;
                        return v > 0 ? acc + v : acc;
                    }, 0);

                    // Soma apenas os valores NEGATIVOS da categoria
                    const totalNegativo = valuesAndNames.reduce((acc, vn) => {
                        const item = dados.find((l) => l[category] === categoryValue);
                        const v = item ? Number(item[vn.value]) || 0 : 0;
                        return v < 0 ? acc + v : acc;
                    }, 0);

                    // Guarda o total (positivo + negativo)
                    dataItem.dataContext._totalPositivo = totalPositivo;
                    dataItem.dataContext._totalNegativo = totalNegativo;

                    // Mostra o total geral (positivo apenas, para o topo)
                    const total = totalPositivo;
                    return `${prefixo} ${total.toLocaleString("pt-BR", {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                    })} ${sufixo}`;
                });
            }
            // ---------------------------------------------------------------------
            //  OCULTAR BULLET QUANDO VALOR = ZERO
            // ---------------------------------------------------------------------
            if (hideZeroBullet) {
                bullet.adapter.add("disabled", function (disabled, target) {
                    if (!target.dataItem) return true;

                    var valor = target.dataItem.valueY;
                    if (valor === 0 || valor === null) return true;

                    // calcula altura real da coluna em pixels
                    var y0 = yAxis.valueToPoint(0).y;
                    var yVal = yAxis.valueToPoint(valor).y;

                    var h = Math.abs(y0 - yVal); // altura da coluna

                    // console.log("ALTURA REAL DA COLUNA:", h);

                    return h < 1; // oculta se for muito pequena
                });
            }
        }

        series.columns.template.tooltipText = `{name}: [bold]${prefixo} {valueY.formatNumber("###,###,###,###.00")} {valueYPercentual}${sufixo}[/]`;

        series.columns.template.fillOpacity = 0.8;

        if (linePattern) {
            // Cria o padrão de listras
            let pattern = new am4core.LinePattern();
            pattern.width = 10; // largura do padrão
            pattern.height = 10; // altura do padrão
            pattern.strokeWidth = 1; // espessura da linha
            pattern.stroke = am4core.color("#ffffff"); // cor da listra
            pattern.rotation = 45; // ângulo das listras (opcional)

            // Aplica o padrão como background (não substituir o fill da cor!)
            series.columns.template.background.fill = pattern;
            series.columns.template.background.fillOpacity = 1; // Ajusta opacidade das listras

            // Mantém a cor original da série
        } else {
            series.columns.template.fillOpacity = 1;
        }
    }
    return chart;
}

export { montarGraficoGroupStackedColumn };
